import fromAnyToString from 'utils/converters/fromAnyToString';
import findFrame from 'utils/dom/findFrame.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';
import isNotFn from 'utils/predicates/function/isNotFn.util';
import generateId from 'utils/values/generateId.util';

const L = logger('messageWindow');

const fromUrlToOrigin = (url) => fromAnyToString(new URL(url).origin);

// SEE: https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage
const messageWindow = (options) => {
  const { origin: originFromOptions, type: typeFromOptions, meta: metaFromOptions, data } = asObject(options);

  const frameInfo = findFrame(options);
  const { contentWindow: target, src } = frameInfo;

  if (!target) return { code: 'fail.target' };
  if (isNotFn(target.postMessage)) return { code: 'fail.post' };

  const origin = fromAnyToString(originFromOptions);
  if (!origin) return { code: 'fail.origin' };

  // NOTE: if this is not checked, postMessage will fail, but not throw an error here, only show it in browser console
  if (fromUrlToOrigin(src) !== origin) return { code: 'fail.src' };

  const message = {
    type: fromAnyToString(typeFromOptions),
    meta: { ...asObject(metaFromOptions), channelId: generateId() },
    data,
  };

  try {
    L.info('()', 'Sending message of type', message.type, 'to', origin, '...');
    target.postMessage(message, origin);

    return { code: 'pass', message };
  } catch (e) {
    L.warn('()', 'Sending message of type', message.type, 'to', origin, 'failed with error', e);
    return { code: 'fail.catch', error: e, channelId: null };
  }
};

// noinspection JSUnusedGlobalSymbols
export default messageWindow;
